/* eslint-disable */
(function() {
  'use strict';

  var $ = require('jquery');
  var _ = require('underscore');

  $(window).on('load', pageLoad);

  //Remove no-js class from page-wrapper
  // $('#page-wrapper').removeClass('no-js');

  /** Handle page load. */
  function pageLoad() {
    $('.HomePage header').show();

    setTimeout(function() {
      $('.HomePage header').addClass('fade-in');
      $('.HomePage footer').fadeIn();
      $('header .grey-bar').addClass('animate');
    }, 600);

    function animateSignposts() {
      var lis = [];

      $('.homepage-signposts .signpost-item').each(function() {
        if ($(this).css('opacity') === '0') {
          lis.push(this);
        }
      });

      var delay = 0;
      $(lis).each(function() {
        $(this)
          .delay(delay)
          .animate(
            {
              opacity: 1,
            },
            1000,
          );
        delay += 100;
      });
    }

    setTimeout(function() {
      $('.load-home-content').addClass('fade-in');
      animateSignposts();
    }, 1300);

    // Highlight top nav - done in javascript to improve performance
    var pathname = window.location.pathname;
    var splitPath = pathname.split('/');

    $('nav ul li a').each(function() {
      var $this = $(this);

      if (
        splitPath.length > 2 &&
        splitPath[2].replace('/', '').toLowerCase() ===
          $this
            .attr('href')
            .replace('/', '')
            .toLowerCase()
      ) {
        $this.addClass('active');
      }
    });

    $('table').each(function() {
      $(this).addClass('table');
      $(this).wrap('<div class="table-responsive"></div>');
    });

    $('.js-toggle-cookie-tab').click(function() {
      $('.cookie-panel-gdpr').slideToggle();
    });
  }
})();
